import { useEffect, useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api, formatPrice, formatDate, ORDER_STATUS } from "../../lib/api";
import { AdminTitle, Panel } from "./AdminUi";

const Stat = ({ label, value, testid }) => (
  <Panel className="p-5">
    <p className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">{label}</p>
    <p className="font-display text-3xl mt-2 text-[#C9A45C]" data-testid={testid}>{value}</p>
  </Panel>
);

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="eyebrow">Chargement…</p>;
  return (
    <div data-testid="admin-overview">
      <AdminTitle title="Tableau de bord">Vue d'ensemble de l'activité (commandes de test incluses).</AdminTitle>
      {!s.email_enabled && <p className="mb-6 text-xs border border-dashed border-[#C9A45C]/40 p-3 text-[#E5C178]" data-testid="email-disabled-notice">Envoi réel des e-mails de confirmation désactivé — les e-mails sont simulés et consignés dans Réglages.</p>}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Chiffre d'affaires" value={formatPrice(s.revenue)} testid="stat-revenue" />
        <Stat label="Commandes payées" value={s.paid_orders} testid="stat-paid-orders" />
        <Stat label="Panier moyen" value={formatPrice(s.average_basket)} testid="stat-average-basket" />
        <Stat label="À préparer" value={s.to_prepare} testid="stat-to-prepare" />
      </div>
      <Panel className="mt-6 p-5">
        <p className="eyebrow mb-4">Chiffre d'affaires — 30 derniers jours</p>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={s.revenue_by_day}>
              <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C9A45C" stopOpacity={0.5} /><stop offset="100%" stopColor="#C9A45C" stopOpacity={0} /></linearGradient></defs>
              <XAxis dataKey="date" tickFormatter={(d) => d.slice(8)} stroke="#666" fontSize={11} />
              <YAxis stroke="#666" fontSize={11} width={40} />
              <Tooltip contentStyle={{ background: "#141414", border: "1px solid #C9A45C55" }} formatter={(v) => formatPrice(v)} />
              <Area type="monotone" dataKey="total" stroke="#C9A45C" fill="url(#g)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Panel>
      <div className="grid lg:grid-cols-3 gap-6 mt-6">
        <Panel className="p-5" data-testid="best-sellers-panel">
          <p className="eyebrow mb-4">Meilleures ventes</p>
          {s.best_sellers.length ? s.best_sellers.map((p, i) => (
            <div key={p.id} className="flex justify-between py-2 border-b border-[#C9A45C]/10 text-sm"><span>{i + 1}. {p.name}</span><span className="text-[#C9A45C]">{p.sold_count} vendu(s)</span></div>
          )) : <p className="text-sm text-[#F8F6F1]/45">Aucune vente pour le moment.</p>}
        </Panel>
        <Panel className="p-5" data-testid="low-stock-panel">
          <p className="eyebrow mb-4">Stock faible (≤ 3)</p>
          {s.low_stock.length ? s.low_stock.map((p) => (
            <div key={p.id} className="flex justify-between py-2 border-b border-[#C9A45C]/10 text-sm"><span className="truncate">{p.name}</span><span className={p.stock === 0 ? "text-red-400" : "text-amber-300"}>{p.stock}</span></div>
          )) : <p className="text-sm text-[#F8F6F1]/45">Aucune alerte.</p>}
        </Panel>
        <Panel className="p-5">
          <p className="eyebrow mb-4">Dernières commandes</p>
          {s.recent_orders.length ? s.recent_orders.map((o) => (
            <div key={o.id} className="py-2 border-b border-[#C9A45C]/10 text-sm">
              <div className="flex justify-between"><span>{o.order_number}</span><span className="text-[#C9A45C]">{formatPrice(o.total)}</span></div>
              <p className="text-xs text-[#F8F6F1]/45">{formatDate(o.created_at)} · {ORDER_STATUS[o.status]}</p>
            </div>
          )) : <p className="text-sm text-[#F8F6F1]/45">Aucune commande.</p>}
        </Panel>
      </div>
    </div>
  );
}
